import { Component, OnInit } from '@angular/core';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { MensagemService } from '../services/mensagem.service';
import { RestClientService } from '../services/restclient.service';
import { LiquidacaoAntecipadaService } from '../services/liquidacaoantecipada.service';
import { BraAlertComponent } from '../componentes/bra-alert/bra-alert.component';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BraConfirmComponent } from '../componentes/bra-confirm/bra-confirm.component';
import { MatDialog } from '@angular/material';
import { Config } from '../services/config';
import { Boleto } from '../modelo/boleto';
import { Contrato } from '../modelo/contrato';

declare var $: any;
declare var Materialize: any;

@Component({
  selector: 'app-liquidacao-parcelas-conclusao',
  templateUrl: './liquidacao-parcelas-conclusao.component.html',
  styleUrls: ['./liquidacao.component.css'],
  providers: [LiquidacaoAntecipadaService, MensagemService, RestClientService]
})
export class LiquidacaoParcelasConclusaoComponent extends AbstractComponent implements OnInit {

  boleto: Boleto;
  contrato: Contrato;

  constructor(
    private sessaoService: SessaoService,
    private liquidacaoAntecipadaService: LiquidacaoAntecipadaService,
    private mensagemService: MensagemService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog) {
    super(sessaoService);
  }

  /**
   * Método chamado na inicialização do componente
   */
  ngOnInit() {
    //Scroll top
    window.scrollTo(0, 0);
    this.boleto = JSON.parse(sessionStorage.getItem('liquidacaoBoleto'));
    this.contrato = JSON.parse(sessionStorage.getItem('liquidacaoContrato'));

    // Close Menu Mobile
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    $(".content").click(function() {
      if (isMobile.matches) {
        $(".page").removeClass("toggled");
      }
    });
  }

  /**
   * Efetua o download do PDF
   */
  download() {
    $('.progress').show();
    this.liquidacaoAntecipadaService.recuperarDadosBoletoRegistrado(this.boleto, this.contrato).subscribe(
      result => {
        if (result.cdMsgemRetorno == "00" || result.cdMsgemRetorno == "0") {
          const data = result.arquivoPdf;
          const fileName = "boleto.pdf";

          const byteCharacters = atob(data.replace(/\s/g, ''));
          const len = byteCharacters.length;
          const uint8Array = new Uint8Array(new ArrayBuffer(len));

          for (let i = 0; i < len; i++) {
            uint8Array[i] = byteCharacters.charCodeAt(i);
          }
          const blob = new Blob([uint8Array], { type: 'application/pdf' });

          if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE
           window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.download = fileName;
            link.href = url;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        } else {
          this.dialog.open(BraAlertComponent, {
            width: Config.POPUP_50VW,
            data: {
              mensagem: result.dsMsgemRetorno + " (" + result.cdMsgemRetorno + ")"
            }
          });
        }
      },
      (error: Response) => {
        this.mensagemService.servicoIndisponivel(this.getMensagem("ERRO_CHAMADA_SERVICO"));
      },
      () => {
        this.spinnerService.hide();
        $('.progress').hide();
      }
    );
  }

  montaPopups(result: any) {
    let dialogRef = this.dialog.open(BraConfirmComponent, {
      width: Config.POPUP_50VW,
      data: {
        mensagem: result.dsMsgemRetorno
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Clicou em Sim
        this.recuperarDadosBoletoNaoRegistrado();
      }
      else {
        // Clicou em Não
        this.dialog.open(BraAlertComponent, {
          width: Config.POPUP_50VW,
          data: {
            mensagem: this.getMensagem("ACESSE_MAIS_TARDE")
          }
        });
      }
    });
  }

  /**
   * Busca o PDF do boleto para download
   */
  recuperarDadosBoletoNaoRegistrado() {
    $('.progress').show();
    this.liquidacaoAntecipadaService.recuperarDadosBoletoNaoRegistrado(this.boleto).subscribe(
      result => {
        var data = result.arquivoPdf;
        var fileName = "boleto.pdf";
        if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE
          var byteCharacters = atob(data);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var blob = new Blob([byteArray], { type: 'application/pdf' });
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.download = fileName;
          link.href = "data:application/pdf;base64," + data;
          document.body.appendChild(link);
          link.click();
        }
      },
      (error: Response) => {
        this.dialog.open(BraAlertComponent, {
          width: Config.POPUP_50VW,
          data: {
            mensagem: this.getMensagem("ERRO_CHAMADA_SERVICO")
          }
        });
      },
      () => {
        this.spinnerService.hide();
        $('.progress').hide();
      });

    }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-liquidacao-cli/liquidacao-parcelas-conclusao.component.ts